import { LegendOrdinal } from '@visx/legend'
import { DataContext } from '@visx/xychart'
import React, { useContext } from 'react'

import S from './ChartLegend.css'

export default function ChartLegend( props ) {
  const { dashed } = props
  const ctx = useContext( DataContext )
  const { colorScale } = ctx 
  
  return (
    <LegendOrdinal
      direction="column"
      itemMargin="16px 0px 16px 0"
      scale={colorScale}
      shapeWidth={32}
      shapeHeight={16}
      shapeStyle={( args ) => {
        const { datum } = args
        const isDashed = dashed[datum]
        return {
          strokeDasharray : isDashed ? '6 7' : null,
          strokeWidth : 5,
          strokeLinecap : 'round',
          transform : 'translate(0, calc(50% - 6px))'
        }
      }}
      shape="line"
      labelAlign="center"
      legendLabelProps={{
        className : S.legendLabel,
        style : {},
      }}
      className={S.legend}/>
  )
}
